import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PublicQuizPage } from './pages/PublicQuizPage';
import { PreviewPage } from './pages/PreviewPage';
import { SharedQuizPage } from './pages/SharedQuizPage';
import { ErrorBoundary } from './components/ErrorBoundary';
import { installGlobalErrorHandlers } from './lib/els';
import './styles.css';

// Захват window.onerror и unhandledrejection — слать в ELS все uncaught
// ошибки с полным stack/URL/user-agent.
installGlobalErrorHandlers();

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route path="/preview/:token" element={<PreviewPage />} />
            <Route path="/share/:token" element={<SharedQuizPage />} />
            <Route path="/:slug" element={<PublicQuizPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

function NotFound() {
  return (
    <div style={{ padding: 48, textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
      <h1>Quiz not found</h1>
      <p style={{ color: '#666' }}>Этого квиза не существует или он был удалён.</p>
    </div>
  );
}
